"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.ddSdk=void 0;var env_1=require("./env"),env_2=require("./env");Object.defineProperty(exports,"ENV_ENUM",{enumerable:!0,get:function(){return env_2.ENV_ENUM}}),Object.defineProperty(exports,"ENV_ENUM_SUB",{enumerable:!0,get:function(){return env_2.ENV_ENUM_SUB}});var sdk_1=require("./sdk");require("./polyfills"),exports.ddSdk=new sdk_1.Sdk(env_1.getENV());


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@3.0.14@dingtalk-jsapi/lib/ddSdk.js
// module id = 83
// module chunks = 106